/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'SIGNED_COPIES_OF_TERMS_AND_CONDITIONS_DOCUMENTS_BETWEEN_THE_FAC',
              'TERMS_AND_CONDITIONS_DOCUMENTS_ARE_UP_TO_DATE',
              'TERMS_AND_CONDITIONS_DOCUMENTS_CLEARLY_AND_ACCURATELY_STATE_THE',
              'COPIES_OF_TERMS_AND_CONDITIONS_DOCUMENTS_ARE_PROVIDED_TO_WORKER',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_follow_any_of_the_following_practices_related_to_o: valueSchema,
  },
}
